<template>
  <FilterPopper>
    <template #default="{ menuOpen }">
      <BaseFilterButton
        :name="'Name'"
        :active="isActive"
        :tagValue="tagValue"
        :menuOpen="menuOpen"
      />
    </template>
    <template #popper>
      <div class="filter-settings">
        <label for="task-name-filter">Task Name</label>
        <input
          id="task-name-filter"
          v-model="nameValue"
          type="text"
          class="filter-input"
          placeholder="Search task name"
        >
      </div>
      <div class="filter-footer">
        <button class="button-text clear-button" @click="clearSelection">Clear Selection</button>
      </div>
    </template>
  </FilterPopper>
</template>

<script setup>
import { computed } from 'vue';
import FilterPopper from '@/components/FilterPopper.vue';
import BaseFilterButton from '@/components/BaseFilterButton.vue';

const props = defineProps({
  modelValue: {
    type: String,
    default: '',
  },
});

const emit = defineEmits(['update:modelValue']);

const nameValue = computed({
  get() {
    return props.modelValue || '';
  },
  set(value) {
    emit('update:modelValue', value || '');
  },
});

const isActive = computed(() => nameValue.value.trim().length > 0);
const tagValue = computed(() => (isActive.value ? '1' : ''));

const clearSelection = () => {
  emit('update:modelValue', '');
};
</script>

<style lang="scss" scoped>
.filter-settings {
  display: flex;
  flex-direction: column;
  padding: 8px;
  border-radius: inherit;
  gap: 6px;
  min-width: 220px;

  label {
    font-size: 12px;
    font-weight: 500;
    color: var(--body-text-color-secondary);
  }
}

.filter-input {
  width: 100%;
  padding: 8px 12px;
  background: white;
  border: 1px solid var(--gray-300);
  border-radius: 4px;
  font-size: 12px;
  outline: none;

  &:focus {
    border-color: var(--color-primary);
    box-shadow: 0 0 3px rgba(var(--color-primary-rgb), 0.2);
  }
}

.filter-footer {
  min-height: 38px;
  width: 100%;
  border-top: 1px solid rgba(140,140,140,0.375);
  padding: 8px;
  text-align: center;

  .clear-button {
    text-align: center;
    @include themify() {
      color: themed('color-danger');
    }

    &[disabled] {
      @include themify() {
        color: themed('color-disabled');
      }
    }
  }
}
</style>